
export const API_ENDPOINTS = {
    //AUTH
    LOGIN: '/login',
    AUTH: 'auth',

    //BRANCHES
    GET_BRANCHES: '/dashboard/branches',
    SYNC_BRANCHES: '/branches/sync',
    CATALOG_BRANCHES: '/catalogs/branches', //Catálogo para obtener las branches del usuario logueado

    //PROFILES
    PROFILES: (id?: number) => id ? `/profiles/${id}` : '/profiles', //Index, Find, Create, Update, Delete
    PERMISSIONS_PROFILE: (id: number) => `/profiles/${id}/permissions`, //Get by profile, Update permissions profile

    //MODULES
    MODULES: '/modules',

    //USERS
    USERS: (id?: number) => id ? `/users/${id}` : '/users', //Index, Find, Create, Update, Delete

    //CASHIERS
    CASHIERS_BY_BRANCHES: '/cash-closing/get-cashiers-by-branches',
    TICKETS_BY_BRANCHES_CASHIERS: '/cash-closing/get-tickets-by-branches&cashiers',
    CASH_CLOSING_DATA: '/cash-closing/get-data',

    //DASHBOARD
    GET_PEDING_BRANCHES_TODAY: '/dashboard/missing-closures',
    BRANCHES_COUNT : '/dashboard/branches/count',


    //LAYOUTS
    GET_LAYOUTS: '/layouts/get-data',
    SAVE_LAYOUT: '/layouts/save',
    DELETE_LAYOUT: (id: number) => `/layouts/${id}`,

    //MANAGERS AND CLOSINGS-CUTS
    MANAGERS_BY_BRANCHES: '/branch-closing/get-managers-by-branches',
    BRANCH_CLOSING_DATA: '/branch-closing/get-data',
    BRANCH_CLOSINGS_CUTS: '/branch-closing/get-branch-closing-with-their-cash-closing',

    //MAILS CONFIG
    MAILS : '/settings/notifications',

    //LOGS
    GET_LOGS: '/logs',
}
